import { render, staticRenderFns } from "./IndicadorInvestigadoresGenero.vue?vue&type=template&id=5a976481&"
import script from "./IndicadorInvestigadoresGenero.vue?vue&type=script&lang=js&"
export * from "./IndicadorInvestigadoresGenero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports